import { ref, watch, computed } from '@vue/composition-api'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import Vue from 'vue'

export default function useMaterialRequestsList() {
  const toast = useToast()
  const refHistoryListTable = ref(null)
  const tableColumns = [
    { key: 'Type', sortable: true },
    { key: 'Description', sortable: true },
    { key: 'From', sortable: true },
    { key: 'To', sortable: true },
    { key: 'Date', sortable: true },
  ]
  const perPage = ref(10)
  const totalAssets = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const startDateFilter = ref('')
  const endDateFilter = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refHistoryListTable.value ? refHistoryListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalAssets.value,
    }
  })

  const refetchData = () => {
    refHistoryListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, statusFilter, sortBy, isSortDirDesc], () => {
    refetchData()
  })

  const fetchAssets = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPage.value * (currentPage.value - 1)
    const asset = JSON.parse(localStorage.getItem('assetDetail'))
    const id = asset.asset_id
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_ITEM_ASSET_HISTORY}${id}?limit=${perPage.value}&offset=${to}&date_start=${startDateFilter.value}&date_end=${endDateFilter.value}&search=${searchQuery.value}`, { headers })
      .then(response => {
          totalAssets.value = response.data.data_count
          callback(response.data.data)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Fetching Data Success',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error Fetching Items list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'super-admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'super-admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchAssets,
    tableColumns,
    perPage,
    currentPage,
    totalAssets,
    dataMeta,
    perPageOptions,
    startDateFilter,
    endDateFilter,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refHistoryListTable,
    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,
    // Extra Filters
    roleFilter,
    statusFilter,
  }
}
